export enum ErrorCode {
  INSUFFICIENT_BALANCE = 'INSUFFICIENT_BALANCE',
  UNSUPPORTED_TOKEN = 'UNSUPPORTED_TOKEN',
  INSUFFICIENT_AMOUNT = 'INSUFFICIENT_AMOUNT',
  SERVER_ERROR = 'SERVER_ERROR',
  SWAP_ROUTE_NOT_FOUND = 'SWAP_ROUTE_NOT_FOUND',
}
export interface ErrorInterface {
  statusCode: number;
  errorCode?: ErrorCode;
  errorMessage?: string;
  details?: any;
}
